import React, { Component } from "react";
import { connect } from "react-redux";
import debounce from "lodash.debounce";
import clonedeep from "lodash.clonedeep";
import classnames from "classnames";
import _ from "i18n";

import {
  setPresentationExtraSlidesContent,
  setDashboardSlides,
  setPresentationCurrentSlideIndex,
  setCommentSlideCode,
  setExtraSlidesInModal,
  setSearchTitleExtraSlide,
  setCategorySelectedItem,
  setExtraSlideUsable,
  setExtraSlideListPaginationPage,
  setShowFrameExtraSlides
} from "Actions";
import { fetchCategoryExtraSlideList, fetchExtraSlideList } from "Thunks";
import { createEditorState } from "Utils";

import { TiArrowSortedDown } from "react-icons/ti";
import draftToHtml from "draftjs-to-html";
import { convertToRaw } from "draft-js";
import RichEditor from "../Common/editor/RichEditor";
// import TTPModal from "../Common/Modal/TTPModal";
import ExtraSlidesModal from "./ExtraSlidesModal";

import styles from "./PreparePresentation.local.scss";

class AddExtraSlidesFrame extends Component {
  constructor(props) {
    super(props);

    this.state = {
      slideContent: createEditorState(""),
      selectedExtraSlide: null,
      page: 1,
      title: "",
      nbrOfSlides: this.getNbrOfSlides(),
      positionsFilterIsVisible: false,
      isExtraSlideModalVisible: false
    };

    this.handleSetExtraSlideContent = debounce(
      this.handleSetExtraSlideContent,
      1000
    );
  }

  componentDidMount() {
    const { slide, addExtraSlide } = this.props;
    if (!addExtraSlide) {
      this.setState({
        ...this.state,
        selectedExtraSlide: clonedeep(slide.selectedExtraSlide),
        page: slide.page,
        slideContent: createEditorState(slide.slideContent),
        title: slide.title
      });
    }
    document.addEventListener(
      "mousedown",
      this.handleClickOutsidePositionsFilter.bind(this)
    );
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevProps.slide.selectedExtraSlide !==
        this.props.slide.selectedExtraSlide &&
      !this.props.addExtraSlide
    ) {
      this.setState({
        ...this.state,
        selectedExtraSlide: clonedeep(this.props.slide.selectedExtraSlide),
        page: this.props.slide.page,
        slideContent: createEditorState(this.props.slide.slideContent),
        title: this.props.slide.title
      });
    }
  }
  //************************* SET DASHBOARD SLIDES TO UPDATE ON ANY CHANGE ******************//
  handleSetDashboardSlides = newExtraSlides => {
    const {
      dashboardData: { slides },
      extraSlides,
      currentSlideIndex,
      dispatch,
      addExtraSlide
    } = this.props;
    const { selectedExtraSlide, page, year } = this.state;

    let newSlides = clonedeep(slides);

    let extra = newExtraSlides ? newExtraSlides : extraSlides.slides;

    if (addExtraSlide) {
      newSlides = newSlides.filter(
        slide => !["EXTRA_SLIDE"].includes(slide.layout.type)
      );
    }
    extraSlides.enabled &&
      extra.forEach(item => {
        if (!addExtraSlide) {
          if (
            page &&
            selectedExtraSlide &&
            selectedExtraSlide.page === page &&
            item.key === selectedExtraSlide.key
          ) {
            newSlides[item.page - 1].labels = {
              fr: item.title,
              en: "",
              nl: ""
            };
            newSlides[item.page - 1].layout.label = item.title;
            newSlides[item.page - 1].layout.components = [item];
          } else if (
            page &&
            selectedExtraSlide &&
            selectedExtraSlide.page !== page &&
            item.key === selectedExtraSlide.key
          ) {
            const slide = newSlides.splice(selectedExtraSlide.page - 1, 1)[0];
            slide.labels = { fr: item.title, en: "", nl: "" };
            slide.layout.label = item.title;
            slide.layout.components = [item];
            newSlides.splice(page - 1, 0, slide);
          }
        } else {
          newSlides.splice(item.page - 1, 0, {
            id: 0,
            labels: { fr: item.title, en: "", ln: "" },
            layout: {
              label: item.title,
              type: "EXTRA_SLIDE",
              config: {
                background: "url(/img/back_blue.png)",
                componentsBackground: "#FFFFFF"
              },
              components: [item]
            }
          });
        }
      });

    if (currentSlideIndex >= newSlides.length) {
      dispatch(setPresentationCurrentSlideIndex(newSlides.length - 1));
      dispatch(setCommentSlideCode(slides[newSlides.length - 1].code));

      const { target } = this.props;
      window.history.pushState(
        "",
        "",
        `/prepare-presentation/${target}/${newSlides.length}?year=${year}`
      );
    }
    dispatch(setDashboardSlides(newSlides));
  };

  getNbrOfSlides = () => {
    const {
      dashboardData: {
        config: { slidesOrder }
      },
      extraSlides: { slides }
    } = this.props;

    return slidesOrder.length + slides.length;
  };

  getPageOptions = () => {
    const { nbrOfSlides } = this.state;

    let options = [];
    for (let i = 1; i <= nbrOfSlides; i++) {
      options.push({ label: i, value: i });
    }
    return options;
  };

  //****************  Cancel Form of Adding and Editing Extra Slide  *************//
  handleCancelForm = () => {
    this.props.dispatch(setShowFrameExtraSlides(false));
  };

  //******************   handle change on text editor  ****************//
  handleChangeExtraSlideContent = event => {
    this.setState({
      slideContent: event
    });
  };

  handleSetExtraSlideContent = ({ content, slideTitle }) => {
    const {
      dispatch,
      extraSlides: { slides }
    } = this.props;

    const { selectedExtraSlide } = this.state;

    slides.forEach(slide => {
      if (slide.key === selectedExtraSlide.key) {
        slide.content = content ? content : slide.content;
        slide.title = slideTitle ? slideTitle : slide.title;
      }
    });

    dispatch(setPresentationExtraSlidesContent(slides));

    this.handleSetDashboardSlides(slides);
  };

  //************************* onClick on an extra slide to SELECT IT ****************//
  handleSelectCurrentSlide = slide => {
    if (slide === undefined) {
      return;
    }
    this.setState({
      selectedExtraSlide: clonedeep(slide),
      page: slide.page,
      slideContent: createEditorState(slide.content),
      title: slide.title
    });

    const { target, dispatch, year } = this.props;

    dispatch(setPresentationCurrentSlideIndex(slide.page - 1));
    dispatch(setCommentSlideCode(0));

    window.history.pushState(
      "",
      "",
      `/prepare-presentation/${target}/${slide.page}?year=${year}`
    );
  };

  //******************   handle change on extra slide TITLE  ****************//
  onChangeSlideTitle = event => {
    this.setState({
      title: event.target.value
    });
  };

  //******************   handle change on extra slide PAGE  ****************//
  onChangeSlidePage = selectedPage => {
    this.setState({
      page: selectedPage ? selectedPage.value : null,
      positionsFilterIsVisible: false
    });
  };

  setPositionsWrapperRef = node => {
    this.positionsWrapperRef = node;
  };
  handleClickOutsidePositionsFilter = event => {
    if (
      this.positionsWrapperRef &&
      !this.positionsWrapperRef.contains(event.target)
    ) {
      this.setState({ ...this.state, positionsFilterIsVisible: false });
    }
  };
  handleDisplayPositionsFilter = () => {
    this.setState(state => {
      return {
        positionsFilterIsVisible: !state.positionsFilterIsVisible
      };
    });
  };

  // *******************     UTILISER UN EXTRA SLIDE      ******************//
  handleUseButtonExtraSlideChosen = () => {
    const { extraSlideUsable, dispatch } = this.props;
    this.setState({
      ...this.state,
      slideContent: createEditorState(extraSlideUsable.slideContent),
      title: extraSlideUsable.slideTitle,
      isExtraSlideModalVisible: false
    });
    setTimeout(function() {
      dispatch(setExtraSlidesInModal(false));
      dispatch(setCategorySelectedItem([]));
      dispatch(setSearchTitleExtraSlide(""));
      dispatch(setExtraSlideListPaginationPage(1));
    }, 500);
  };

  handleUseExtraSlide = () => {
    const { dispatch } = this.props;
    dispatch(fetchExtraSlideList("0"));
    dispatch(fetchCategoryExtraSlideList());
    dispatch(setExtraSlidesInModal(true));
    let extraSlideUsable = {
      slideIdClicked: null,
      slideTitle: "",
      slideContent: ""
    };
    dispatch(setExtraSlideUsable(extraSlideUsable));
    this.setState({
      ...this.state,
      isExtraSlideModalVisible: true
    });
  };

  handleCancelModal = () => {
    const { dispatch } = this.props;
    this.setState({
      ...this.state,
      isExtraSlideModalVisible: false
    });
    setTimeout(function() {
      dispatch(setExtraSlidesInModal(false));
      dispatch(setSearchTitleExtraSlide(""));
      dispatch(setCategorySelectedItem([]));
      dispatch(setExtraSlideListPaginationPage(1));
    }, 500);
  };

  // *******************     ADD AND EDIT EXTRA SLIDE      ******************//
  handleAddExtraSlide = () => {
    let {
      extraSlides: { slides },
      dispatch,
      addExtraSlide
    } = this.props;

    const {
      nbrOfSlides,
      title,
      page,
      slideContent,
      selectedExtraSlide
    } = this.state;

    if (!addExtraSlide) {
      slides.forEach(slide => {
        if (slide.key === selectedExtraSlide.key) {
          if (slide.page !== page) {
            slides.forEach(s => {
              if (s.page >= page && selectedExtraSlide.page > page) {
                s.page = s.page + 1;
              } else {
                if (s.page <= page && selectedExtraSlide.page < page) {
                  s.page = s.page - 1;
                }
              }
            });
          }
          slide.page = page;
          slide.title = title;
          slide.content = draftToHtml(
            convertToRaw(slideContent.getCurrentContent())
          );
        }
      });
    } else {
      slides.forEach(slide => {
        if (slide.page >= page) {
          slide.page = slide.page + 1;
        }
      });

      slides.push({
        title: title,
        content: draftToHtml(convertToRaw(slideContent.getCurrentContent())),
        page: page,
        key: Math.random()
          .toString(36)
          .substring(5)
      });
      this.handleCancelForm();
    }

    slides.sort((a, b) => (a.page > b.page ? 1 : b.page > a.page ? -1 : 0));

    dispatch(setPresentationExtraSlidesContent(slides));

    this.handleSetDashboardSlides(slides);

    this.handleSelectCurrentSlide(
      slides.filter(slide => slide.page === page)[0]
    );

    this.setState({
      ...this.setState,
      nbrOfSlides: nbrOfSlides + 1,
      page: 1,
      slideContent: createEditorState(""),
      selectedExtraSlide: null,
      title: ""
    });
    if (!addExtraSlide) {
      this.props.dispatch(setShowFrameExtraSlides(false));
    }
  };

  render() {
    const { page, title, slideContent, positionsFilterIsVisible } = this.state;
    const { addExtraSlide } = this.props;
    return (
      <div className={styles.add_extra_slide_container}>
        <div className={styles.header}>
          <h2>
            {addExtraSlide
              ? _("ajouterExtraSlideTitle")
              : _("editExtraSlideTitle")}{" "}
            :
          </h2>
          <span className={styles.button} onClick={this.handleUseExtraSlide}>
            {_("useAModele")}
          </span>
        </div>
        <div className={styles.body}>
          <div className={styles.form}>
            <div style={{ width: "82%" }}>
              <span>{_("slideTitle")}</span>
              <input
                className={styles.title_input}
                placeholder={"Veuillez saisir le titre de votre slide..."}
                value={title}
                onChange={this.onChangeSlideTitle}
              />
            </div>
            <div style={{ width: "18%" }}>
              <span>{_("slidePosition")}</span>
              <div
                ref={this.setPositionsWrapperRef.bind(this)}
                className={
                  styles.costumed_select +
                  " " +
                  (positionsFilterIsVisible
                    ? styles.costumed_select_opened
                    : "")
                }
              >
                <div className={styles.costumed_select_header}>
                  <span>
                    {page &&
                      this.getPageOptions().find(obj => obj.value === page)
                        .label}
                  </span>
                  <div className={styles.actions}>
                    <div>
                      <span
                        className={styles.action}
                        onClick={this.handleDisplayPositionsFilter}
                      >
                        <TiArrowSortedDown />
                      </span>
                    </div>
                  </div>
                </div>
                {positionsFilterIsVisible && (
                  <div className={styles.costumed_select_body}>
                    <div className={styles.costumed_select_body_options}>
                      {this.getPageOptions().map((item, index) => (
                        <div
                          key={index}
                          className={styles.costumed_select_body_option}
                          onClick={() => this.onChangeSlidePage(item)}
                        >
                          {item.label}
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
          <div>
            <RichEditor
              content={slideContent}
              onEditorChange={this.handleChangeExtraSlideContent}
            />
          </div>
        </div>
        <div className={styles.footer}>
          <span
            className={classnames(styles.button, styles.default)}
            onClick={this.handleCancelForm}
          >
            {_("cancel")}
          </span>
          <span
            className={classnames(styles.button, styles.validate)}
            onClick={this.handleAddExtraSlide}
          >
            {_("validate")}
          </span>
        </div>
        {this.state.isExtraSlideModalVisible ? (
          <ExtraSlidesModal
            onCancel={this.handleCancelModal}
            onClickUse={this.handleUseButtonExtraSlideChosen}
          />
        ) : (
          ""
        )}
      </div>
    );
  }
}

// Connected Component
const mapStateToProps = state => ({
  extraSlides: state.presentation.presentationConfig.extraSlides,
  target: state.presentation.presentationConfig.target,
  dashboardData: state.dashboard.data,
  currentSlideIndex: state.presentation.currentSlideIndex,
  extraSlideUsable: state.preparePresentation.extraSlideUsable
});

export default connect(mapStateToProps)(AddExtraSlidesFrame);



// WEBPACK FOOTER //
// ./src/components/PreparePresentation/AddExtraSlidesFrame.js